import { useMemo } from 'react';

import { Flex, keyframes } from '@chakra-ui/react';

import { StarEmptyIcon, StarHalfIcon, StarIcon } from '../icons';

const animationKeyframes = keyframes`
  0% { opacity: .3 }
  50% { opacity: 1}
  100% { opacity: .3 }
`;

const numberOfStars = 5;

export function Rating({
  rating,
  color = 'primary.orange',
  isLoading = false,
}: {
  rating?: number;
  color?: string;
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}) {
  const stars = useMemo(() => {
    const renderedStars = [];

    const starStyles = {
      color: isLoading || rating === 0 ? 'supportGray.40' : color,
      height: '16px',
      width: '16px',
    };

    for (let i = 0; i < numberOfStars; i++) {
      const difference = (rating ?? 5) - i;
      if (difference <= 0) renderedStars.push(<StarEmptyIcon key={i} {...starStyles} />);
      else if (difference < 1) renderedStars.push(<StarHalfIcon key={i} {...starStyles} />);
      else renderedStars.push(<StarIcon key={i} {...starStyles} />);
    }

    return renderedStars;
  }, [color, isLoading, rating]);

  return (
    <Flex
      animation={isLoading ? `${animationKeyframes} 2s ease-in-out infinite` : 'none'}
      aria-label={`Rated ${rating} out of ${numberOfStars}`}
      display='inline-flex'
      role='img'
    >
      {stars}
    </Flex>
  );
}
